import * as Models from './payer-onboarding-generated';
import { AppContentCardModel } from './payer-onboarding-generated';

export interface IPayerOnboardingAppState {
	userPrefersVoiceCalls: boolean;
	mobileNumberRequest: IPayerOnboardingMobileNumberRequest | null;
	firstName: string;
	lastName: string;
	enteredMobileNumber: string;
	enteredEmailAddress: string;
	country: Models.Country;
	personCountryInfo: Models.PersonCountryInfo;
	getAppUrl: string;
	appLinkSmsSent: boolean;
	loginToken?: string;
	identityToken?: string;
	appContentCards: AppContentCardModel[] | null;
}

export interface IPayerOnboardingMobileNumberRequest {
	mobileNumber: Models.PayerOnboardingMobileNumber;
	mobileRequestToken: string;
}

export function defaultAppState(): IPayerOnboardingAppState {
	return {
		firstName: '',
		lastName: '',
		mobileNumberRequest: null,
		userPrefersVoiceCalls: false,
		enteredMobileNumber: '',
		enteredEmailAddress: '',
		country: Models.Country.US,
		getAppUrl: '',
		appLinkSmsSent: false,
		personCountryInfo: {
			CountryCode: Models.Country.US,
			PostalCodeCommonName: 'Zip code',
		},
		appContentCards: null,
	};
}
